module.exports = __webpack_public_path__ + "static/media/niamh_english_irish.1f058a75.mp3";